import * as React from 'react';
import { BrowserRouter as Router, Routes, Route} from 'react-router-dom'; 
import { ThemeProvider, createTheme } from '@mui/material/styles';
import Navbar from './components/NavbarMainPage/NavbarMainPage.jsx'
// import { AuthProvider } from './contexts/AuthContext';
import Home from './pages/Home/Home';
import ForgotPassword from './pages/Login/ForgotPassword.tsx'
import SignPigeon from './pages/Sign/SignPigeon.jsx';
import LoginPigeon from './pages/Login/LoginPigeon.jsx';
import PigeonsNew from './pages/Pigeons/PigeonsNew.jsx';
import Panel from './pages/Pigeons/Panel.jsx';
import Pedigree from './pages/Pigeons/Pedigree.jsx';
import Flights from './pages/Pigeons/Flights.jsx';
import Pairing from './pages/Pigeons/Pairing.jsx';
import { SubscriptionProvider } from './contexts/SubscriptionContext.jsx';
import SubscriptionGate from './components/subscription/SubscriptionGate.jsx';



const theme = createTheme({
  palette: {
    primary: {
      main: 'rgb(40, 56, 70)', 
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <SubscriptionProvider>
      {/* <AuthProvider> */}
        <Router>
          <div className="App">
            <div>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/home" element={<Home />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/pigeons-new" element={<PigeonsNew />} />
                <Route path="/pigeons-register" element={<SignPigeon />} />
                <Route path="/pigeons-login" element={<LoginPigeon />} /> 
                <Route path="/panel" element={<Panel />} /> 
                <Route
                  path="/pedigree"
                  element={(
                    <SubscriptionGate featureKey="pedigree">
                      <Pedigree />
                    </SubscriptionGate>
                  )}
                />
                <Route
                  path="/flights"
                  element={(
                    <SubscriptionGate featureKey="flights">
                      <Flights />
                    </SubscriptionGate>
                  )}
                />
                <Route
                  path="/pairing"
                  element={(
                    <SubscriptionGate featureKey="pairing">
                      <Pairing />
                    </SubscriptionGate>
                  )}
                /> 
              </Routes>
            </div>
            {/* Footer */}
          </div>
        </Router>
     {/* </AuthProvider>*/}
     </SubscriptionProvider>
    </ThemeProvider>
  );
}

export default App;
